/*
* <license header>
*/

import React from 'react'
import {
  View,
  Flex,
  Heading,
  Text,
  TextField,
  Button,
  Form
} from '@adobe/react-spectrum'

const MOCK_CAPABILITIES = [
  { key: 'browse', title: 'Browse', description: 'Browse projects and workspaces', enabled: true },
  { key: 'create', title: 'Create', description: 'Create projects and workspaces', enabled: true },
  { key: 'modify', title: 'Modify', description: 'Modify projects and workspaces', enabled: true },
  { key: 'delete', title: 'Delete', description: 'Delete projects and workspaces', enabled: false }
]

export const AdobeConsoleConfigSection = () => (
  <View
    UNSAFE_style={{
      border: '1px solid var(--card-border)',
      borderRadius: '8px',
      padding: '1.25rem',
      backgroundColor: 'var(--white)'
    }}
    marginBottom="size-300"
  >
    <Heading level={2} UNSAFE_style={{ margin: 0, marginBottom: '0.5rem', fontSize: '1.125rem' }}>
      Adobe Console configuration
    </Heading>
    <Text UNSAFE_style={{ color: 'var(--gray-600)', fontSize: '0.875rem', marginBottom: '1rem' }}>
      Configure the connection between AppBuilder Factory and Adobe Developer Console. A valid API token is required to browse, create, modify and delete projects and workspaces. Create or manage credentials in the{' '}
      <a href="https://developer.adobe.com/console" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--spectrum-global-color-blue-600)' }}>
        Adobe Developer Console
      </a>
      .
    </Text>

    <Form necessityIndicator="label">
      <Flex direction="column" gap="size-200" marginBottom="size-300">
        <TextField
          label="API Token"
          placeholder="Enter your Adobe I/O API token"
          type="password"
          width="size-4600"
          maxWidth="100%"
          description="Token is used for verification and is never stored."
        />
      </Flex>

      <Flex gap="size-200" justifyContent="end">
        <Button variant="secondary">Test connection</Button>
        <Button variant="accent">Save</Button>
      </Flex>
    </Form>

    <View marginTop="size-400">
      <Heading level={3} UNSAFE_style={{ margin: 0, marginBottom: '0.75rem', fontSize: '1rem', fontWeight: 600 }}>
        Connection capabilities
      </Heading>
      <Flex gap="size-200" wrap>
        {MOCK_CAPABILITIES.map(({ key, title, description, enabled }) => (
          <View
            key={key}
            UNSAFE_style={{
              border: `1px solid ${enabled ? 'var(--color-border-positive)' : 'var(--card-border)'}`,
              borderRadius: '8px',
              padding: '1rem',
              backgroundColor: enabled ? 'rgba(38, 142, 108, 0.08)' : 'var(--gray-75)',
              minWidth: '180px',
              flex: '1 1 180px'
            }}
          >
            <View
              UNSAFE_style={{
                width: 8,
                height: 8,
                borderRadius: '50%',
                backgroundColor: enabled ? 'var(--color-background-positive)' : 'var(--gray-400)'
              }}
            />
            <Text UNSAFE_style={{ fontWeight: 600, fontSize: '0.875rem', display: 'block', marginTop: '0.25rem' }}>
              {title}
            </Text>
            <Text UNSAFE_style={{ color: 'var(--gray-600)', fontSize: '0.75rem', marginTop: '0.25rem' }}>
              {description}
            </Text>
          </View>
        ))}
      </Flex>
    </View>
  </View>
)
